import * as React from 'react';
import RunsheetInvoiceItemsData from './RunSheetInvoiceItems';

interface RunSheetDriverUpdateCallout {
    chargeCalloutFee: boolean;
    loading: boolean;
    errors: any;
}

interface RunSheetDriverCalloutProps {
    invoiceItems: ItemList[];
    invoiceItemTypes: ItemTypeList[];
    gst: number;
    job: Job;
    updateJob(job: Job): void;
    save(): void;
}

interface Job {
    runsheetId: number;
    scheduleDateFormatted: string;
    truck: string;
    jobId: number;
    siteAddress: string;
    updateTypeId: number;     //1=Callout, 2=Plan Changes
    estimatedTime: string;
    departureTime: string;
    siteArrivalTime: string;
    downTime: string;
    siteCompletionTime: string;
    driverNotes: string;
    chargeCalloutFee: number;
    noCalloutInvoiceNotes: string;
    calloutNotes: string;
    planChangesReason: string;
    officeNotes: string;
    items: JobItem[];
    invoiceItems: ExtraInvoiceItem[];
}

interface JobItem {
    id: number;
    typeId: number;
    type: string;
    item: string;
    itemId: number;
    hirePeriod: number;
    unitNumber: string; //if site address has a unit number
    quantityTotal: number;
    quantity: number;
    quantityScheduled: number;
    quantityType: string;
    price: number;
    overhireRate: number;
}

interface ExtraInvoiceItem {
    rowIndex: number;
    id: number;
    itemId: number;
    itemTypeId: number;
    scheduleId: number;
    jobQuoteItemId: number;
    rate: number;
    gst: number;
    amount: number;
    description: string;
    active: boolean;
}

interface ItemTypeList {
    id: number;
    name: string;
    chargeGst: boolean;
}

interface ItemList {
    id: number;
    jobQuoteItemId: number;
    name: string;
    chargeGst: boolean;
}

export default class RunSheetDriverCallout extends React.Component<RunSheetDriverCalloutProps, RunSheetDriverUpdateCallout> {
    constructor(props: any) {
        super(props);

        this.state = {
            chargeCalloutFee: false,
            loading: false,
            errors: {}
        };
    }

    handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        let change: any = {};
        change = this.props.job;
        change[e.target.name] = e.target.value;
        this.setState({ errors: errors })
        this.props.updateJob(change);
    }

    updateCalloutItems = (invoiceItem: Job) => {
        var currentJob = this.props.job;

        currentJob.chargeCalloutFee = invoiceItem.chargeCalloutFee;
        currentJob.calloutNotes = invoiceItem.calloutNotes;
        currentJob.noCalloutInvoiceNotes = invoiceItem.noCalloutInvoiceNotes;

        currentJob.invoiceItems = invoiceItem.invoiceItems;

        this.props.updateJob(currentJob);
    }

    updateChargeCalloutFee = (chargeCalloutFee: boolean) => {
        this.setState({ chargeCalloutFee: chargeCalloutFee });
    }

    deleteError = (errorName: string) => {
        var errorList = this.state.errors;
        delete errorList[errorName];
        this.setState({ errors: errorList });
    }

    save = () => {
        this.props.save();
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        let job = this.props.job;
        let invoiceitems = <RunsheetInvoiceItemsData showItems={false} items={this.props.invoiceItems} itemTypes={this.props.invoiceItemTypes} gst={this.props.gst} invoiceItemModalType={2} invoiceItem={job} chargeCalloutFee={this.state.chargeCalloutFee} errors={this.state.errors} deleteError={this.deleteError} updateData={this.updateCalloutItems} updateChargeCalloutFee={this.updateChargeCalloutFee} />

        return (
            <div>
                <div className="marginLeft10">
                    <h5>
                        <span>{job.truck}</span>
                        <span className="marginLeft20">{job.jobId}</span>
                        <span className="marginLeft20">{job.siteAddress}</span>
                    </h5>
                </div>
                <div className="marginLeft10">{job.driverNotes}</div>
                <div>
                    <label className="input-group--inline" htmlFor="estimatedTime">
                        <span className="label-small">Est. Time:</span>
                        <span className="marginLeft10" id="estimatedTime">{job.estimatedTime}</span>
                    </label>
                    <label className="input-group--inline" htmlFor="departureTime">
                        <span className="label-small">Departure:</span>
                        <input className="marginLeft10" id="departureTime" name="departureTime" type="time" value={job.departureTime} onChange={(e) => this.handleChange(e)} />
                    </label>
                    <label className="input-group--inline" htmlFor="siteArrivalTime">
                        <span className="label-small">Arrival:</span>
                        <input className="marginLeft10" id="siteArrivalTime" name="siteArrivalTime" type="time" value={job.siteArrivalTime} onChange={(e) => this.handleChange(e)} />
                    </label>
                    <label className="input-group--inline" htmlFor="downTime">
                        <span className="label-small">Down Time:</span>
                        <input className="marginLeft10" id="downTime" name="downTime" type="time" value={job.downTime} onChange={(e) => this.handleChange(e)} />
                    </label>
                    <label className="input-group--inline" htmlFor="siteCompletionTime">
                        <span className="label-small">Completion:</span>
                        <input className="marginLeft10" id="siteCompletionTime" name="siteCompletionTime" type="time" value={job.siteCompletionTime} onChange={(e) => this.handleChange(e)} />
                    </label>
                </div>
                <div>
                    {job.items.map((item, index) =>
                        <div key={index}>
                            <span className="marginLeft10">{item.type}</span>
                            <span className="marginLeft20">{item.item}</span>
                            <span className="marginLeft20">{item.quantityType}</span>
                        </div>
                    )}
                </div>
                <div className="marginLeft10 runsheet-callout--width">
                    {invoiceitems}
                </div>
                <button className="defaultbutton-next" type="button" onClick={this.save}>Save</button>
            </div>


        );

    }

};

